export default __webpack_public_path__ + "static/media/foto-rostro.325aaf4d.png";